var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 749,
    height: 419,
    viewBox: "0 0 749 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.712 -173.538C566.115 -211.405 398.016 -342.382 439.764 -248.279C481.512 -154.175 597.786 -352.203 679.823 -276.222C761.86 -200.242 944.809 661.505 710.809 352.005C476.809 42.505 609.942 430.779 413.758 352.005C217.573 273.231 312.104 473.814 147.693 352.005C-16.7182 230.196 -108.69 -135.671 228.712 -173.538Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob2.2f5d458eab94cb43e70a7becb4c71c0c.svg";
export { ForwardRef as ReactComponent };